var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isPlainObject = void 0;
  // borrowed from https://github.com/lodash/lodash/blob/master/isPlainObject.js
  function isPlainObject(value) {
    if (typeof value !== "object" || value === null) {
      return false;
    }
    if (Object.getPrototypeOf(value) === null) {
      return true;
    }
    let proto = value;
    while (Object.getPrototypeOf(proto) !== null) {
      proto = Object.getPrototypeOf(proto);
    }
    return Object.getPrototypeOf(value) === proto;
  }
  exports.isPlainObject = isPlainObject;
  return exports;
}